import React from "react";
import { LeadCardShimmerProps } from "../type";

const LeadCardShimmer: React.FC<LeadCardShimmerProps> = ({
  className = "",
  showAvatarShimmer = true,
  showNameShimmer = true,
  showOutboundModalitiesShimmer = true,
  showHumanAssistedShimmer = true,
  showMessageShimmer = true,
  showDateShimmer = true,
  showLeadIdShimmer = true,
  showTagsShimmer = true,
  showInboundModalitiesShimmer = true,
}) => {
  return (
    <div
      className={`w-full border-b border-border-gray dark:border-border-gray-dk px-[12px] py-[16px] flex flex-col gap-[8px] min-w-0 bg-pure-white dark:bg-pure-white-dk ${className}`}
    >
      <div className="flex items-center justify-between gap-[8px] min-w-0">
        <div className="flex items-center gap-[5px] min-w-0 flex-1">
          {showAvatarShimmer && (
            <div className="shrink-0 relative">
              <div className="w-6 h-6 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-full animate-pulse"></div>
              <div className="w-[6px] h-[6px] bg-pure-white dark:bg-pure-white-dk rounded-full absolute bottom-0 right-0 flex flex-col items-center justify-center">
                <div className="w-[4px] h-[4px] bg-[var(--color-gray-100)] dark:bg-[var(--color-gray-100-dk)] rounded-full"></div>
              </div>
            </div>
          )}
          {showNameShimmer && (
            <div className="h-4 w-24 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
          )}
        </div>

        <div className="flex items-center gap-[8px] shrink-0">
          {showOutboundModalitiesShimmer && (
            <div className="w-16 h-5 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-[4px] animate-pulse"></div>
          )}
          {showHumanAssistedShimmer && (
            <div className="w-8 h-5 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-[4px] animate-pulse"></div>
          )}
        </div>
      </div>

      <div className="flex items-center gap-[8px] justify-between">
        {showMessageShimmer && (
          <div className="h-4 w-32 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
        )}
        {showDateShimmer && (
          <div className="h-4 w-12 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse shrink-0"></div>
        )}
      </div>

      <div className="flex items-center justify-between min-w-0">
        <div className="flex items-center gap-[4px] min-w-0 flex-1">
          {showLeadIdShimmer && (
            <div className="h-4 w-16 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse shrink-0"></div>
          )}
          {showTagsShimmer && (
            <>
              <div className="w-4 h-4 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-full animate-pulse shrink-0"></div>
              <div className="w-4 h-4 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded-full animate-pulse shrink-0"></div>
            </>
          )}
        </div>
        {showInboundModalitiesShimmer && (
          <div className="flex items-center gap-[4px] shrink-0">
            <div className="w-3 h-3 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
            <div className="w-3 h-3 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadCardShimmer;
